export default {
  PRODUCT_DELIVERIES_FETCHED: 'PRODUCT_DELIVERIES_FETCHED',
  PRODUCT_DELIVERIES_LOAD: 'PRODUCT_DELIVERIES_LOAD',
  PRODUCT_DELIVERIES_TEMPLATES_FETCHED: 'PRODUCT_DELIVERIES_TEMPLATES_FETCHED',
  PRODUCT_DELIVERIES_TEMPLATES_LOAD: 'PRODUCT_DELIVERIES_TEMPLATES_LOAD',
  PRODUCT_DELIVERIES_DETAIL: 'PRODUCT_DELIVERIES_DETAIL',
  PRODUCT_DELIVERIES_BUTTON_LOAD: 'PRODUCT_DELIVERIES_BUTTON_LOAD',
};
